module.exports = __webpack_public_path__ + "static/media/pov_vertex_figure_GreatStellatedDodecahedron.0473dfd0.png";